/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListPostsParams,
  PaginatedPosts,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List Posts
 */
export const listPosts = (
    params?: MaybeRefOrGetter<ListPostsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedPosts>(
      {url: `/posts`, method: 'GET',
        params, signal
    },
      );
    }




export const getListPostsQueryKey = (params?: MaybeRefOrGetter<ListPostsParams>,) => {
    return [
    'posts', ...(params ? [params] : [])
    ] as const;
    }


export const getListPostsQueryOptions = <TData = Awaited<ReturnType<typeof listPosts>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListPostsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPosts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListPostsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPosts>>> = ({ signal }) => listPosts(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPosts>>, TError, TData>
}

export type ListPostsQueryResult = NonNullable<Awaited<ReturnType<typeof listPosts>>>
export type ListPostsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List Posts
 */

export function useListPosts<TData = Awaited<ReturnType<typeof listPosts>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListPostsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPosts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPostsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Mark Posts Read
 */
export const markPostsRead = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/posts/read`, method: 'PATCH', signal
    },
      );
    }




export const getMarkPostsReadMutationKey = () => ['markPostsRead'] as const;

export const getMarkPostsReadMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markPostsRead>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markPostsRead>>, TError,void, TContext> => {

const mutationKey = getMarkPostsReadMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markPostsRead>>, void> = () => {


          return  markPostsRead()
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkPostsReadMutationResult = NonNullable<Awaited<ReturnType<typeof markPostsRead>>>

    export type MarkPostsReadMutationError = ErrorType<void>


    /**
 * @summary Mark Posts Read
 */
export const useMarkPostsRead = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markPostsRead>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof markPostsRead>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMarkPostsReadMutationOptions(options), queryClient);
    }
